(ns storrito.wallet
  "Shared constants and helpers of the wallet slice, used by the wallet UI
   and by `app.wallet.*`, so client and server cannot drift apart. The
   control server cannot reach this namespace; `control.wallet-checkout`
   duplicates the numbers it needs, with pointers here.")

(def minimum-amount
  ;; Below the $5 auto-top-up threshold an automatic top-up would
  ;; re-trigger immediately, and the storage flat-fee alone burns $3.10
  ;; per month.
  5)

(def maximum-amount
  ;; The product cap per charge, aligned with the old checkout's $2000
  ;; period maximum, so the legacy panel's "Add $N now" (the period
  ;; amount, at most $2000) always passes. The Paddle "Credits refill"
  ;; price itself would allow up to 5000 (its quantity.maximum, checked
  ;; in the sandbox).
  2000)

(def on-demand-threshold
  ;; Fixed, whatever the amount: the storage flat-fee alone costs $3.10
  ;; per month, so a lower threshold could run dry between two checks.
  5)

(defn on-demand?
  "True for a subscription whose item is the $0 \"Credits on demand\"
   price. Recognized by the unit price rather than the price id, so that
   client and server agree without configuration."
  [paddle-subscription]
  (= "0"
     (get-in (first (:items paddle-subscription))
             [:price :unit_price :amount])))

(defn subscription-amount
  "The period amount of a legacy monthly or yearly subscription: its item
   quantity, one credit per USD. nil without a subscription. Used as the
   Auto Top-Up fallback for legacy subscribers who never picked an amount."
  [paddle-subscription]
  (:quantity (first (:items paddle-subscription))))
